/** @format */
import { MonetaryPaymentConfirmationComponent } from './confirmation/monetary-payment-confirmation/monetary-payment-confirmation.component';
import { StudyVoucherVerifyIdentityComponent } from './confirmation/study-voucher-payment-confirmation/study-voucher-verify-identity/study-voucher-verify-identity.component';
import { OpenUniversityCartComponent } from './open-university-cart.component';

/**
 * Defines the steps of the cart purchase wizard. The first two steps are implemented in {@link OpenUniversityCartComponent}.
 * The third step (payment) is performed in an external payment system. Step 4 (confirmation) is implemented in
 * {@link MonetaryPaymentConfirmationComponent} or {@link StudyVoucherVerifyIdentityComponent}, depending on the selected payment method.
 * The last step (activating studies) is actually not part of the purchase wizard at all,
 * but a completely separate wizard. However, it's visible in the progress bar of the purchase wizard to signal to the user
 * that the studies must be activated before the process is complete.
 */
export const CART_PURCHASE_WIZARD_STEP_KEYS: readonly string[] = [
    'OPEN_UNIVERSITY_CART.WIZARD.TEACHING.NAME',
    'OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.NAME',
    'OPEN_UNIVERSITY_CART.WIZARD.PAYMENT.NAME',
    'OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.AUTHENTICATION',
    'OPEN_UNIVERSITY_CART.WIZARD.ACTIVATE_CART.NAME',
];

export const CART_PURCHASE_WIZARD_STEP_KEYS_AUTO_ACTIVATE: readonly string[] = [
    'OPEN_UNIVERSITY_CART.WIZARD.TEACHING.NAME',
    'OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.NAME',
    'OPEN_UNIVERSITY_CART.WIZARD.PAYMENT.NAME',
    'OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.PURCHASE_COMPLETED',
];

export enum STEP {
    CHECK_SELECTIONS = 0,
    CONTACT_INFORMATION = 1,
    PAYMENT = 2,
    CONFIRMATION = 3,
    ACTIVATE_STUDIES = 4,
}

export type CartPaymentType = 'MONETARY_PAYMENT' | 'STUDY_VOUCHER_PAYMENT';
